import React from 'react'
import { Link } from 'react-router-dom';
import { ReactComponent as ChewyTeamSVG } from '../images/chewy-team.svg';
import { ReactComponent as CaptTeamSVG } from '../images/amazon-ads-team.svg';
import { ReactComponent as FdtTeamSVG } from '../images/amazon-fulfillment-team.svg';
import { ReactComponent as EmTeamSVG } from '../images/nordstrom-team.svg';
import '../css/App.css';

const Home = () => {
  return (
    <div>
      <div className="row">
          <div className="column one">
            <ChewyTeamSVG/>
            <div className="columnTitle">
              CHEWY SHOPPING<br/>
              2023 - 2025
            </div>
            <div className="columnText">
              I led Autoship Design, a multi-disciplinary team of designers and researchers that envisioned, designed and delivered improvements to Autoship and the adjacent shopping funnel for Chewy. We followed a research-driven methodology that uncovered customer experience issues through direct customer feedback, generative research and customer service contact data analysis.
            </div>
            <Link to="/chewy">
            <div className="columnButton first">
              CASE STUDIES
            </div>
            </Link>
          </div>
          <div className="column two">
            <CaptTeamSVG/>
            <div className="columnTitle">
              AMAZON ADS<br/>
              2018 - 2023
            </div>
            <div className="columnText">
              I established and led Campaign &amp; Product Technology Design, a multi-disciplinary team of designers, researchers and technologists that envisioned, designed and delivered new products for Amazon Ads. We followed a data-driven methodology that uncovered issues early in the product development lifecycle. This enabled us to mitigate the impact of one-way door decisions and costly post-launch fixes.
            </div>
            <Link to="/advertising">
            <div className="columnButton second">
              CASE STUDIES
            </div>
            </Link>
          </div>
        <div className="column three">
          <FdtTeamSVG/>
          <div className="columnTitle">
              AMAZON OPERATIONS<br/>
              2015 - 2018
          </div>
          <div className="columnText">
              I established and led Fulfillment Design Technology, a team of technologists that solved critical user experience problems for Amazon Operations. We researched, designed, built, tested and deployed hardware and software prototypes that reduced the complexity and improved the safety of fulfillment processes.
          </div>
          <Link to="/fulfillment">
            <div className="columnButton third">
              CASE STUDIES
            </div>
            </Link>
        </div>
        <div className="column four">
          <EmTeamSVG/>
            <div className="columnTitle">
              NORDSTROM RETAIL<br/>
              2010 - 2015
            </div>
            <div className="columnText">
              I established and co-led Emerging Media, a team of technologists that delivered interactive branded experiences for Nordstrom retail. We researched, designed, built, tested, deployed and maintained hardware and software that was purpose-built for these retail environments and drove brand awareness while providing a memorable customer experience.
          </div>
          <Link to="/nordstrom">
            <div className="columnButton fourth">
              CASE STUDIES
            </div>
          </Link>
        </div>
      </div>
  </div>
  )
}

export default Home